module.exports = __webpack_public_path__ + "img/ewa-banner.3dd71e53.png";